import { OrderItemState } from './enums/OrderItemState'
import Money from '../shared/Money'
import Product from './product/Product'
import OrderItemJson from './interfaces/OrderItemJson'
import RentalRequest from 'src/models/order/product/RentalRequest'
import ReservationPickupRequest from 'src/models/order/product/ReservationPickupRequest'
import RentalRequestJson from 'src/models/order/interfaces/RentalRequestJson'
import ReservationPickupRequestJson from 'src/models/order/interfaces/ReservationPickupRequestJson'
import ReservationPlanningRequest from 'src/models/order/product/ReservationPlanningRequest'
import ReservationPlanningRequestJson from 'src/models/order/interfaces/ReservationPlanningRequestJson'

export class OrderItem {
  id: string
  state: OrderItemState
  total: Money
  product: Product
  deeplink: string | null

  constructor(
    id: string,
    state: OrderItemState,
    total: Money,
    product: Product,
    deeplink: string | null,
  ) {
    this.id = id
    this.state = state
    this.total = total
    this.product = product
    this.deeplink = deeplink
  }

  isFulfilled() {
    return this.state === OrderItemState.STATE_FULFILLED
  }

  isProcessingError() {
    return this.state === OrderItemState.STATE_PROCESSING_ERROR
  }

  static fromJson(data: OrderItemJson): OrderItem {
    let product: Product

    if (data.product.productType === RentalRequest.PRODUCT_TYPE) {
      product = RentalRequest.fromJson(data.product as RentalRequestJson)
    } else if (
      data.product.productType === ReservationPickupRequest.PRODUCT_TYPE
    ) {
      product = ReservationPickupRequest.fromJson(
        data.product as ReservationPickupRequestJson,
      )
    } else if (
      data.product.productType === ReservationPlanningRequest.PRODUCT_TYPE
    ) {
      product = ReservationPlanningRequest.fromJson(
        data.product as ReservationPlanningRequestJson,
      )
    } else {
      throw new Error('unknown product type')
    }
    return new this(
      data.id,
      data.state,
      Money.fromJson(data.total),
      product,
      data.deeplink,
    )
  }

  toJson(): OrderItemJson {
    return {
      id: this.id,
      state: this.state,
      total: this.total.toJson(),
      product: this.product.toJson(),
      deeplink: this.deeplink,
    }
  }
}
